(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerWrapper = this.closest('.header-wrapper');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const searchModal = this.header.querySelector('details-modal');
      if (searchModal && searchModal.isOpen()) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.headerWrapper && this.headerWrapper.classList.add('header-wrapper--solid');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.headerWrapper && this.headerWrapper.classList.add('header-wrapper--solid');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.headerWrapper && this.headerWrapper.classList.remove('header-wrapper--solid');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  class ShippingCalculator extends HTMLElement {
    connectedCallback() {
      this.countryEl = this.querySelector('#Estimate-Country');
      this.provinceEl = this.querySelector('#Estimate-Province');
      this.provinceWrapper = this.querySelector('#Estimate-Province-Wrapper');
      this.zipEl = this.querySelector('#Estimate-Zip');
      this.submitBtn = this.querySelector('#Estimate-Submit');
      this.resultsEl = this.querySelector('#Estimate-Results');

      if (this.countryEl) {
        this.countryEl.addEventListener('change', this._onCountryChange.bind(this));
        // Initialize provinces based on default country selection
        this._updateProvinces();
      }

      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', this._onEstimate.bind(this));
      }
    }

    _onCountryChange() {
      this._updateProvinces();
    }

    _updateProvinces() {
      if (!this.countryEl || !this.provinceEl || !this.provinceWrapper) return;
      
      const selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
      if (!selectedOption) return;

      const provincesJson = selectedOption.getAttribute('data-provinces');
      if (!provincesJson) return;

      try {
        const provinces = JSON.parse(provincesJson);
        this.provinceEl.innerHTML = '';
        
        if (provinces && provinces.length > 0) {
          provinces.forEach((province) => {
            const opt = document.createElement('option');
            opt.value = province[0];
            opt.textContent = province[1];
            this.provinceEl.appendChild(opt);
          });
          this.provinceWrapper.style.display = 'block';
        } else {
          this.provinceWrapper.style.display = 'none';
        }
      } catch (e) {
        console.error('Error parsing provinces:', e);
        this.provinceWrapper.style.display = 'none';
      }
    }

    _onEstimate() {
      if (!this.countryEl || !this.submitBtn || !this.resultsEl) return;

      const country = this.countryEl.value;
      const province = this.provinceWrapper.style.display !== 'none' ? this.provinceEl.value : '';
      const zip = this.zipEl ? this.zipEl.value : '';

      this.submitBtn.textContent = 'ESTIMATING...';
      this.submitBtn.disabled = true;
      this.resultsEl.innerHTML = '';

      let url = `/cart/shipping_rates.json?shipping_address[country]=${encodeURIComponent(country)}&shipping_address[province]=${encodeURIComponent(province)}&shipping_address[zip]=${encodeURIComponent(zip)}`;

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error('Network error');
          return response.json();
        })
        .then((data) => {
          this.submitBtn.textContent = 'ESTIMATE';
          this.submitBtn.disabled = false;

          if (data && data.shipping_rates && data.shipping_rates.length > 0) {
            let html = `<p>There are ${data.shipping_rates.length} shipping rates available for this address:</p><ul>`;
            data.shipping_rates.forEach((rate) => {
              const formattedPrice = this._formatCurrency(rate.price, rate.currency);
              html += `<li>${rate.name}: <strong>${formattedPrice}</strong></li>`;
            });
            html += '</ul>';
            this.resultsEl.innerHTML = html;
          } else {
            this.resultsEl.innerHTML = '<p>No shipping rates available for this destination.</p>';
          }
        })
        .catch((err) => {
          console.error(err);
          this.submitBtn.textContent = 'ESTIMATE';
          this.submitBtn.disabled = false;
          this.resultsEl.innerHTML = '<p>Could not retrieve shipping rates. Please check your address details or try again.</p>';
        });
    }

    _formatCurrency(amount, currency) {
      const parsedAmount = parseFloat(amount);
      if (isNaN(parsedAmount)) return amount;
      
      if (currency === 'IDR' || String(window.Shopify?.currency?.active || '').toUpperCase() === 'IDR') {
        const formatted = new Intl.NumberFormat('id-ID', {
          style: 'currency',
          currency: 'IDR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(parsedAmount);
        return formatted.replace('Rp', 'Rp ').replace('IDR', 'Rp');
      }
      
      return `${currency} ${parsedAmount.toFixed(2)}`;
    }
  }

  customElements.define('shipping-calculator', ShippingCalculator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
